import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const IosPlaceholder = ({ height = 21, width = 21, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox={`0 0 ${height} ${width}`} {...props}>
    <rect
      xmlns="http://www.w3.org/2000/svg"
      opacity="0.2"
      width={width}
      height={height}
      rx="4"
      fill="#B56DC6"
    />
  </SvgIcon>
);
